import * as React from 'react'
import MUIDialogActions from '@mui/material/DialogActions'

const DialogActions = (props) => <MUIDialogActions {...props} />

export default DialogActions
